export default __webpack_public_path__ + "static/google-store-585a3b175977953c36a3fafdd17ae8db.jpg";